const LOCALHOST_SERVER_URL = 'https://medyoucate-api-staging.herokuapp.com';

const getRootServerUrl = () =>
  process.env.NEXT_PUBLIC_SERVER_URL || LOCALHOST_SERVER_URL;

export default getRootServerUrl;
